"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionValueTypeEnum = void 0;
exports.ExpressionValueTypeEnum = {
    Single: 'single',
    Array: 'array',
    Unknown: 'unknown'
};
